import i18n from '@/i18n';
import dayjs from 'dayjs';
import Vue from 'vue';
const vue = new Vue();

// 获取图片操作权限
export const getImageBtnAuth = ({ selectImages, toolFolderList, pageValue, sourceName = '' }) => {
  const ipp_role = localStorage.getItem('ipp_role');
  const { category_id, reviewed_type } = pageValue;
  // 全部图像、临时分类 可能存在 AI、HI 同时存在，如果存在 AI 类型，以 AI 类型的文件
  // 获取选中的图片
  const isHasAi = selectImages
    .map(x => {
      return {
        ...x,
        imageType: x.hi === 1 ? 'hi' : x.roi_labelindex == 0 ? 'ui' : 'ai'
      };
    })
    .some(x => x.imageType === 'ai');

  const a1 = { label: i18n.t('RoiBrowser.utils.074098-0'), value: 1 };
  const a2 = { label: i18n.t('RoiBrowser.utils.074098-1'), value: 2 };

  // Xcube参考库
  const a11 = { label: i18n.t('RoiBrowser.utils.074098-2'), value: 11 };
  const a12 = { label: i18n.t('RoiBrowser.utils.074098-3'), value: 12 };
  const a13 = { label: i18n.t('RoiBrowser.utils.074098-4'), value: 13 };

  // 团队参考库
  const a21 = { label: i18n.t('RoiBrowser.utils.074098-5'), value: 21 };
  const a22 = { label: i18n.t('RoiBrowser.utils.074098-6'), value: 22 };
  const a23 = { label: i18n.t('RoiBrowser.utils.074098-7'), value: 23 };

  // 荟萃墙
  const a31 = { label: i18n.t('RoiBrowser.utils.074098-8'), value: 31 };
  const a32 = { label: i18n.t('RoiBrowser.utils.074098-9'), value: 32 };
  const a33 = { label: i18n.t('RoiBrowser.utils.074098-10'), value: 33 };

  // 人工识别
  const a41 = { label: i18n.t('RoiBrowser.utils.074098-11'), value: 41 };
  const a42 = { label: i18n.t('RoiBrowser.utils.074098-12'), value: 42 };
  const a43 = { label: i18n.t('RoiBrowser.utils.074098-1'), value: 43 };
  const a44 = { label: i18n.t('RoiBrowser.utils.074098-13'), value: 42 };

  // 临时分类
  const a51 = toolFolderList.map(x => {
    return {
      ...x,
      label: '复制到 ' + x.title,
      value: 51
    };
  });
  const a52 = toolFolderList.map(x => {
    return {
      ...x,
      label: '移入 ' + x.title,
      value: 52
    };
  });
  const a53 = { label: i18n.t('RoiBrowser.utils.074098-1'), value: 53 };
  const a54 = { label: i18n.t('RoiBrowser.utils.074098-16'), value: 54 };

  // 回收站
  const a61 = { label: i18n.t('RoiBrowser.utils.074098-16'), value: 61 };
  const a62 = { label: i18n.t('RoiBrowser.utils.074098-17'), value: 62 };

  // 示例图片
  const a71 = { label: i18n.t('RoiBrowser.utils.074098-7'), value: 71 };

  const a110 = { label: i18n.t('RoiBrowser.utils.074098-31'), value: 110 };
  const a111 = { label: i18n.t('RoiBrowser.utils.074098-32'), value: 111 };
  const a112 = { label: i18n.t('RoiBrowser.utils.074098-33'), value: 112 };

  const a113 = { label: i18n.t('RoiBrowser.utils.074098-35'), value: 113 };

  // 后续建议采用新的写法
  const B001 = { label: '复制', value: 'B001', form: '站位参考库', to: 'Xcube参考库' };
  const B002 = { label: '复制', value: 'B002', form: '站位参考库', to: '团队参考库' };
  const B003 = { label: '移除', value: 'B003', form: 'Xcube参考库', to: '回收站', operate_name: '移除图片' };
  const B004 = { label: '移除', value: 'B004', form: '团队参考库', to: '回收站', operate_name: '移除图片' };

  if (category_id === -100) {
    // 全部图像
    if (ipp_role === 'superadmin') {
      return isHasAi ? [a41, ...a51, a2] : [a21, a31, a41, ...a51, a2];
    } else if (ipp_role === 'administrator') {
      return isHasAi ? [a41, ...a51, a2] : [a21, a31, a41, ...a51, a2];
    } else if (ipp_role === 'user') {
      return isHasAi ? [a41, ...a51, a2] : [a21, a31, a41, ...a51, a2];
    }
  } else if (category_id === -1) {
    // Xcube 参考库
    if (ipp_role === 'superadmin') {
      if (sourceName === 'identify-right') {
        return [B003];
      }
      return [a13];
    }
  } else if (category_id === -2) {
    // 示例图片不支持操作
    if (selectImages && selectImages.length && selectImages[0].is_demo_image) return [];

    if (sourceName === 'identify-right') {
      return [B004];
    }

    // 团队参考库
    if (ipp_role === 'superadmin') {
      return [a31, a41, ...a51, a23];
    } else if (ipp_role === 'administrator') {
      return [a31, a41, ...a51, a23];
    } else if (ipp_role === 'user') {
      return [...a51];
    }
  } else if (category_id === -3) {
    // 荟萃墙
    if (ipp_role === 'superadmin') {
      return [a33];
    } else if (ipp_role === 'administrator') {
      return [a33];
    }
  } else if (category_id === -4) {
    // 人工识别
    if (ipp_role === 'superadmin') {
      return [a21, a31, a113, a42, ...a52, a43];
    } else if (ipp_role === 'administrator') {
      return [a21, a31, a113, a42, ...a52, a43];
    } else if (ipp_role === 'user') {
      return [a42, ...a52, a43];
    }
  } else if (category_id === -5) {
    // 机器识别
    if (ipp_role === 'superadmin') {
      return [a44, ...a52, a2];
    } else if (ipp_role === 'administrator') {
      return [a44, ...a52, a2];
    } else if (ipp_role === 'user') {
      return [a44, ...a52, a2];
    }
  } else if (category_id === -6) {
    // 示例图片
    if (ipp_role === 'superadmin') {
      return [a71];
    }
  } else if (category_id === -7) {
    // 站位参考库
    // 站位参考库
    if (sourceName === 'identify-left') {
      if (ipp_role === 'superadmin') {
        return [B001];
      } else if (ipp_role === 'administrator') {
        return [B002];
      }
    }

    // reviewed_type 1 已审核，2 待审核
    if (ipp_role === 'superadmin') {
      return reviewed_type === 1 ? [a110] : [a111, a112];
    } else if (ipp_role === 'administrator') {
      return reviewed_type === 1 ? [a110] : [a111, a112];
    }
  } else if (category_id === -1000) {
    // 回收站
    if (ipp_role === 'superadmin') {
      return [a61, a62];
    } else if (ipp_role === 'administrator') {
      return [a61, a62];
    } else if (ipp_role === 'user') {
      return [a61];
    }
  } else {
    // 临时文件夹
    const a = a52.filter(x => x.id != category_id);
    if (ipp_role === 'superadmin') {
      return [...a, a44, a54, a53];
    } else if (ipp_role === 'administrator') {
      return [...a, a44, a54, a53];
    } else if (ipp_role === 'user') {
      return [...a, a44, a54, a53];
    }
  }
};

// 获取分类操作权限
export const getFolderBtnAuth = ({ item, pageValue, sourceName = '' }) => {
  const { category_id, reviewed_type } = pageValue;
  const ipp_role = localStorage.getItem('ipp_role');

  const a0 = { label: i18n.t('RoiBrowser.utils.074098-18'), value: 0 };
  const a1 = { label: i18n.t('RoiBrowser.utils.074098-19'), value: 1 };
  const a2 = { label: i18n.t('RoiBrowser.utils.074098-20'), value: 2 };

  const a11 = { label: i18n.t('RoiBrowser.utils.074098-3'), value: 11, tip: i18n.t('RoiBrowser.utils.074098-21') };
  const a12 = { label: i18n.t('RoiBrowser.utils.074098-3'), value: 12, tip: i18n.t('RoiBrowser.utils.074098-22') };
  const a13 = { label: i18n.t('RoiBrowser.utils.074098-3'), value: 13, tip: i18n.t('RoiBrowser.utils.074098-23') };
  const a14 = { label: i18n.t('RoiBrowser.utils.074098-2'), value: 14, tip: i18n.t('RoiBrowser.utils.074098-21') };
  const a15 = { label: i18n.t('RoiBrowser.utils.074098-2'), value: 15, tip: i18n.t('RoiBrowser.utils.074098-22') };
  const a16 = { label: i18n.t('RoiBrowser.utils.074098-2'), value: 16, tip: i18n.t('RoiBrowser.utils.074098-23') };
  const a17 = { label: i18n.t('RoiBrowser.utils.074098-24'), value: 17 };

  const a21 = { label: i18n.t('RoiBrowser.utils.074098-6'), value: 21, tip: i18n.t('RoiBrowser.utils.074098-21') };
  const a22 = { label: i18n.t('RoiBrowser.utils.074098-6'), value: 22, tip: i18n.t('RoiBrowser.utils.074098-22') };
  const a23 = { label: i18n.t('RoiBrowser.utils.074098-6'), value: 23, tip: i18n.t('RoiBrowser.utils.074098-23') };
  const a24 = { label: i18n.t('RoiBrowser.utils.074098-5'), value: 24, tip: i18n.t('RoiBrowser.utils.074098-21') };
  const a25 = { label: i18n.t('RoiBrowser.utils.074098-5'), value: 25, tip: i18n.t('RoiBrowser.utils.074098-22') };
  const a26 = { label: i18n.t('RoiBrowser.utils.074098-5'), value: 26, tip: i18n.t('RoiBrowser.utils.074098-23') };

  const a31 = { label: i18n.t('RoiBrowser.utils.074098-9'), value: 31, tip: i18n.t('RoiBrowser.utils.074098-21') };
  const a32 = { label: i18n.t('RoiBrowser.utils.074098-9'), value: 32, tip: i18n.t('RoiBrowser.utils.074098-22') };
  const a33 = { label: i18n.t('RoiBrowser.utils.074098-9'), value: 33, tip: i18n.t('RoiBrowser.utils.074098-23') };
  const a34 = { label: i18n.t('RoiBrowser.utils.074098-8'), value: 34, tip: i18n.t('RoiBrowser.utils.074098-21') };
  const a35 = { label: i18n.t('RoiBrowser.utils.074098-8'), value: 35, tip: i18n.t('RoiBrowser.utils.074098-22') };
  const a36 = { label: i18n.t('RoiBrowser.utils.074098-8'), value: 36, tip: i18n.t('RoiBrowser.utils.074098-23') };

  const a41 = { label: i18n.t('RoiBrowser.utils.074098-13'), value: 41, tip: i18n.t('RoiBrowser.utils.074098-21') };
  const a42 = { label: i18n.t('RoiBrowser.utils.074098-13'), value: 42, tip: i18n.t('RoiBrowser.utils.074098-22') };
  const a43 = { label: i18n.t('RoiBrowser.utils.074098-13'), value: 43, tip: i18n.t('RoiBrowser.utils.074098-23') };
  const a44 = { label: i18n.t('RoiBrowser.utils.074098-11'), value: 44, tip: i18n.t('RoiBrowser.utils.074098-21') };
  const a45 = { label: i18n.t('RoiBrowser.utils.074098-11'), value: 45, tip: i18n.t('RoiBrowser.utils.074098-22') };
  const a46 = { label: i18n.t('RoiBrowser.utils.074098-11'), value: 46, tip: i18n.t('RoiBrowser.utils.074098-23') };

  const a51 = { label: i18n.t('RoiBrowser.utils.074098-25'), value: 51, tip: i18n.t('RoiBrowser.utils.074098-21') };
  const a52 = { label: i18n.t('RoiBrowser.utils.074098-25'), value: 52, tip: i18n.t('RoiBrowser.utils.074098-22') };
  const a53 = { label: i18n.t('RoiBrowser.utils.074098-25'), value: 53, tip: i18n.t('RoiBrowser.utils.074098-23') };
  const a54 = { label: i18n.t('RoiBrowser.utils.074098-26'), value: 54, tip: i18n.t('RoiBrowser.utils.074098-21') };
  const a55 = { label: i18n.t('RoiBrowser.utils.074098-26'), value: 55, tip: i18n.t('RoiBrowser.utils.074098-22') };
  const a56 = { label: i18n.t('RoiBrowser.utils.074098-26'), value: 56, tip: i18n.t('RoiBrowser.utils.074098-23') };

  const a61 = { label: i18n.t('RoiBrowser.utils.074098-34'), value: 61, tip: i18n.t('RoiBrowser.utils.074098-21') };
  const a62 = { label: i18n.t('RoiBrowser.utils.074098-34'), value: 62, tip: i18n.t('RoiBrowser.utils.074098-22') };
  const a63 = { label: i18n.t('RoiBrowser.utils.074098-34'), value: 63, tip: i18n.t('RoiBrowser.utils.074098-23') };
  const a64 = { label: i18n.t('RoiBrowser.utils.074098-35'), value: 64, tip: i18n.t('RoiBrowser.utils.074098-21') };
  const a65 = { label: i18n.t('RoiBrowser.utils.074098-35'), value: 65, tip: i18n.t('RoiBrowser.utils.074098-22') };
  const a66 = { label: i18n.t('RoiBrowser.utils.074098-35'), value: 66, tip: i18n.t('RoiBrowser.utils.074098-23') };

  const a100 = { label: i18n.t('RoiBrowser.utils.074098-27'), value: 100 };
  const a101 = { label: i18n.t('RoiBrowser.utils.074098-4'), value: 101 };

  const a102 = { label: i18n.t('RoiBrowser.utils.074098-28'), value: 102 };
  const a103 = { label: i18n.t('RoiBrowser.utils.074098-29'), value: 103 };
  const a104 = item.collect_status ? a103 : a102;

  const a105 = { label: i18n.t('RoiBrowser.utils.074098-30'), value: 105 };

  const a110 = { label: i18n.t('RoiBrowser.utils.074098-31'), value: 110 };
  const a111 = { label: i18n.t('RoiBrowser.utils.074098-32'), value: 111 };
  const a112 = { label: i18n.t('RoiBrowser.utils.074098-33'), value: 112 };

  // 后续建议采用新的写法
  const B001 = { label: '复制', value: 'B001', form: '站位参考库', to: 'Xcube参考库' };
  const B002 = { label: '复制', value: 'B002', form: '站位参考库', to: '团队参考库' };
  const B003 = { label: '移除', value: 'B003', form: 'Xcube参考库', to: '回收站', operate_name: '移除图片' };
  const B004 = { label: '移除', value: 'B004', form: '团队参考库', to: '回收站', operate_name: '移除图片' };

  if (category_id === -1) {
    // Xcube参考库
    if (ipp_role === 'superadmin') {
      if (sourceName === 'identify-right') {
        return [B003];
      }

      if (item.id < 100000) return [];
      return item.status === 1 ? [a2, a104, a17] : [a1, a104, a17, a100];
    }
    return [a104];
  } else if (category_id === -2) {
    if (sourceName === 'identify-right') {
      return [B004];
    }

    // 团队参考库 （新建、删除分类都和人工识别同步）
    if (ipp_role === 'superadmin') {
      return [a34, item.status === 1 ? a101 : a104, a100];
    } else if (ipp_role === 'administrator') {
      return [a34, item.status === 1 ? a101 : a104, a100];
    }
    return [a104];
  } else if (category_id === -3) {
    // 荟萃墙
    if (ipp_role === 'superadmin') {
      return [a104, a105, a100];
    } else if (ipp_role === 'administrator') {
      return [a104, a105, a100];
    }
    return [a104];
  } else if (category_id === -4) {
    // 人工识别
    if (ipp_role === 'superadmin') {
      return [a24, a34, a64, item.status === 1 ? a101 : a104, a100];
    } else if (ipp_role === 'administrator') {
      return [a24, a34, a64, item.status === 1 ? a101 : a104, a100];
    }
    return [a104];
  } else if (category_id === -5) {
    // 机器识别
    if (ipp_role === 'superadmin') {
      return [a43, a101, a104];
    } else if (ipp_role === 'administrator') {
      return [a43, a101, a104];
    }
    return [a104];
  } else if (category_id === -6) {
    // 示例图片
    if (ipp_role === 'superadmin') {
      return [a100];
    }
  } else if (category_id === -7) {
    // 站位参考库
    if (sourceName === 'identify-left') {
      if (ipp_role === 'superadmin') {
        return [B001];
      } else if (ipp_role === 'administrator') {
        return [B002];
      }
    }

    // reviewed_type 1 已审核，2 待审核
    if (ipp_role === 'superadmin') {
      return reviewed_type === 1 ? [a110] : [a111, a112];
    } else if (ipp_role === 'administrator') {
      return reviewed_type === 1 ? [a110] : [a111, a112];
    }
  }
  return [];
};

/**
 * 将时间范围按固定等份拆分
 * @param {Date|string|number} startTime - 开始时间（Date 对象、时间戳或字符串）
 * @param {Date|string|number} endTime - 结束时间（Date 对象、时间戳或字符串）
 * @param {number} parts - 需要拆分的份数
 * @returns {Date[]} 拆分后的时间点数组（包含开始和结束时间）
 */
function splitTimeRange(startTime, endTime, parts) {
  // 统一转换为 Date 对象
  const start = new Date(startTime);
  const end = new Date(endTime);

  // 计算总时间差（毫秒）
  const totalMilliseconds = end.getTime() - start.getTime();

  // 计算每份的时间间隔（毫秒）
  const interval = totalMilliseconds / parts;

  // 生成拆分时间点
  const result = [];
  for (let i = 0; i <= parts; i++) {
    const timestamp = start.getTime() + interval * i;
    result.push(new Date(timestamp));
  }

  return result;
}

export const getFormatDateTime = e => {
  const { x } = e.items;
  const len = x ? x.length : 0;
  const { Roi_time_s: start, Roi_time_e: end, coordRange_0, coordRange_1 } = e || {};
  let Roi_time_s = '';
  let Roi_time_e = '';

  if (start && !end) {
    // 快捷方式
    if (start === '-24 hour') {
      Roi_time_s = dayjs().subtract(24, 'hour').format('YYYY-MM-DD HH:mm:ss');
      Roi_time_e = dayjs().format('YYYY-MM-DD HH:mm:ss');
    } else if (start === '-3 day') {
      Roi_time_s = dayjs().subtract(3, 'day').format('YYYY-MM-DD HH:mm:ss');
      Roi_time_e = dayjs().format('YYYY-MM-DD HH:mm:ss');
    } else if (start === '-7 day') {
      Roi_time_s = dayjs().subtract(7, 'day').format('YYYY-MM-DD HH:mm:ss');
      Roi_time_e = dayjs().format('YYYY-MM-DD HH:mm:ss');
    } else if (start === '-15 day') {
      Roi_time_s = dayjs().subtract(15, 'day').format('YYYY-MM-DD HH:mm:ss');
      Roi_time_e = dayjs().format('YYYY-MM-DD HH:mm:ss');
    } else if (start === '-31 day') {
      Roi_time_s = dayjs().subtract(31, 'day').format('YYYY-MM-DD HH:mm:ss');
      Roi_time_e = dayjs().format('YYYY-MM-DD HH:mm:ss');
    } else if (start === '-3 month') {
      Roi_time_s = dayjs().subtract(3, 'month').format('YYYY-MM-DD HH:mm:ss');
      Roi_time_e = dayjs().format('YYYY-MM-DD HH:mm:ss');
    } else if (start === '-6  month') {
      Roi_time_s = dayjs().subtract(6, 'month').format('YYYY-MM-DD HH:mm:ss');
      Roi_time_e = dayjs().format('YYYY-MM-DD HH:mm:ss');
    } else if (start === '-12 month') {
      Roi_time_s = dayjs().subtract(1, 'year').format('YYYY-MM-DD HH:mm:ss');
      Roi_time_e = dayjs().format('YYYY-MM-DD HH:mm:ss');
    } else {
      // vue.$message.error('不支持类型');
      Roi_time_s = -1;
      Roi_time_e = '';
    }
  } else if (start && end) {
    // 具体时间
    Roi_time_s = start;
    Roi_time_e = end;
  } else {
    vue.$message.error('日期格式错误');
  }

  if (coordRange_0 || coordRange_0 === 0) {
    // 选择柱形图条

    const timePoints = splitTimeRange(Roi_time_s, Roi_time_e, len);

    if (coordRange_1) {
      Roi_time_s = dayjs(timePoints[coordRange_0]).format('YYYY-MM-DD HH:mm:ss');
      Roi_time_e = dayjs(timePoints[coordRange_1 + 1]).format('YYYY-MM-DD HH:mm:ss');
    } else {
      Roi_time_s = dayjs(timePoints[coordRange_0]).format('YYYY-MM-DD HH:mm:ss');
      Roi_time_e = dayjs(timePoints[coordRange_0 + 1]).format('YYYY-MM-DD HH:mm:ss');
    }
  }

  return { Roi_time_s, Roi_time_e };
};
